import React from 'react'
import { ProviderSignalingBridge, SIGNALING_PROVIDERS } from 'src/live'

export default function AgoraSignallingComponent(props) {
  return (
    <ProviderSignalingBridge
      {...props}
      signalingProvider={SIGNALING_PROVIDERS.agoraRtm}
    />
  )
}
